import moment from 'moment';
import img1 from "./../../assets/assets_theme/img/avatar/1.jpg"

export const exportTaskReportPdf = (datas, filename) => {
    console.log(datas, 'datasssdfa')
    // let data = JSON.stringify(this.state.users);

  let data_content = '';

  const printWindow = window.open('', '_blank');

  const content = `<tr style="height: 10px">
                <th >#</th>
                <th >Time</th>
                <th >Description</th>
                <th >Date</th>
              </tr>`;

  
  datas.task.forEach((data, index) => {
    data_content += `<tr>
        <td ><strong>${index + 1}</strong></td>
        <td ><strong>${data.time}</strong></td>
        <td ><strong>${data.description}</strong></td>
        <td >${moment(datas.created_at).format('DD MMMM YYYY')}</td>
      <tr>`
  });

  // data_content = JSON.stringify(data_content);
  // data_content = data_content.replace(/(\r\n|\n|\r)/gm, "");

  printWindow.document.write(`
    <html>
      <head>
        <title>Print Preview</title>
        <style>
          @page { 
            size: A4;
            margin: 0mm;
          }
          html,
        body {
            width: 210mm;
            height: 297mm;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }  
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
          }
          .content {
            width: 80%;
            height: 90%;
            padding: 10px;
            box-sizing: border-box;
            font-family: Arial, sans-serif;
          }

          .avatar {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 50px;
            line-height: 36px;
            text-align: center;
            border-radius: 100%;
            background-color: #f5f6f7;
            color: #8b95a5;
            text-transform: uppercase;
          }

          .img-pull-right {
            float: right;
            width: 200px; 
            height: 150px;
            object-fit: fix;
            margin-left: 15px; 
            margin-bottom: 15px; 
          }
           


          #customers {
            font-family: Arial, Helvetica, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          #customers td, #customers th {
            border: 1px solid #ddd;
            padding: 8px;
          }

          #customers tr:nth-child(even){background-color: #f2f2f2;}

          #customers tr:hover {background-color: #ddd;}

          #customers th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: center;
            background-color: #48b0f7;
            color: white;
            font-size: 15
          }
           #customers td {
            font-size: 12
          } 
        
            
        </style>
      </head>
      <body>
        <div class="content">
          <div style="text-align: center"> <h3>${filename}</h3> Name: ${ datas.user.last_name ? datas.user.last_name : ''} ${ datas.user.first_name ? datas.user.first_name : ''} ${ datas.user.nick_name ? datas.user.nick_name : ''} </div> <br />
          <div class="media" style={{alignItems: 'center'}}>
             
          </div>
        <table id="customers">
            <thead>
                ${content}
            </thead>
            <tbody>
              ${data_content}
            </tbody>
          </table>
        </div>
      </body>

       <script>

          window.onload = function() {
            window.print();
          }
          window.onafterprint = function() {
                    window.close();
          };



        </script>
    </html>
  `);

  printWindow.document.close();
  };


  // <img class="img-pull-right" src=${datas.user.profile_url ? datas.user.profile_url : img1} alt="..." />


  // <div class="media" style={{alignItems: 'center'}}>
  //   <img class="avatar" src={data.user.profile_url ? data.user.profile_url : img1} alt="..." />
  //   <div class="media-body">
  //   <h6> 
  //     { data.user.first_name ? data.user.first_name : ''} { data.user.last_name ? data.user.last_name : ''} { data.user.nick_name ? data.user.nick_name : ''}
  //   </h6>
  //   </div>
  // </div>